<template>
  <div class="row">
    <div class="col-md-12">
      <loading v-if="showContent"></loading>
      <h2 class="titulo"> {{ bloco.nome }} </h2>
      <iframe id="myframe" style="border: none;" :src="iframeSrc"   width="100%" height="400"></iframe>
    </div>
  </div>
</template>

<script>
  import {getTokenChat} from '../../helpers/api';
  import Loading from '../common/Loading.vue';

  export default {
    components: {
      Loading
    },
    name: "Chat",
    props: ['bloco'],
    data() {
      return {
        iframeSrc: null,
        maxcast:'https://www.maxcast.com.br',
        showContent: true,
      }
    },
    mounted() {
      let self = this;
      $(function(){
        $('#myframe').load(function () {
          setTimeout(function(){
            self.showContent = false;
          },1000);
        });
      });
      getTokenChat().then(function (response) {
        if (response.data.result.data) {
          self.iframeSrc = window.config.CHAT_URL + "chat?token=" + response.data.result.data;
        }
      })
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/home/Chat.vue